import request from "@/utlis/request";

//  新闻列表
export function getNewsListApi(params) {
  return request({
    url: "/news/admin/list",
    method: "get",
    params,
  });
}

//  新闻分类
export function getNewsCategoriesApi() {
  return request({
    url: "/news/categories",
    method: "get",
  });
}

//  材料列表
export function getMaterialListApi(params) {
  return request({
    url: "/material/admin/list",
    method: "get",
    params,
  });
}

//  登录
export function loginApi(data) {
  return request({
    url: "/web/user/login",
    method: "post",
    data,
  });
}

//  注册
export function registerApi(data) {
  return request({
    url: "/web/user/register",
    method: "post",
    data,
  });
}

//  修改用户信息
export function updateUserInfoApi(data) {
  return request({
    url: "/web/user/update",
    method: "post",
    data,
  });
}

// 修改用户密码
export function updatePasswordApi(data) {
  return request({
    url: "/web/user/update/password",
    method: "post",
    data,
  });
}

//  城市列表
export function getCityListApi(params) {
  return request({
    url: "/city/admin/info",
    method: "get",
    params,
  });
}

//  业务列表
export function getBusinessListApi(params) {
  return request({
    url: "/web/business/list",
    method: "get",
    params,
  });
}

export function uploadFileApi(file) {
  const form = new FormData();
  form.append("file", file);
  return request({
    url: "/file/upload",
    method: "post",
    data: form,
    transformRequest: [
      (data, headers) => {
        delete headers["Content-Type"];
        return data;
      },
    ],
  });
}

//  创建订单
export function createOrderApi(data) {
  return request({
    url: "/order/create",
    method: "post",
    data,
  });
}

export function simulatePaymentApi(data) {
  return request({
    url: "/order/payment/simulate",
    method: "post",
    data,
  });
}

export function getPaymentStatusApi(params) {
  return request({
    url: "/order/payment/status",
    method: "get",
    params,
    silent: true,
    hideLoading: true,
  });
}

export function resumePaymentApi(data) {
  return request({
    url: "/order/payment/resume",
    method: "post",
    data,
  });
}

//  订单列表
export function getOrderListApi(params) {
  return request({
    url: "/order/list",
    method: "get",
    params,
  });
}

// 获取新闻详情
export function getNewsDetailApi(id) {
  return request({
    url: `/news/detail/${id}`,
    method: "get"
  });
}

// FAQ 常见问题列表
export function getFaqListApi(params) {
  return request({
    url: "/faq/web/list",
    method: "get",
    params,
  });
}

// 网站基本参数
export function getSiteConfigApi() {
  return request({
    url: "/site-config/web/info",
    method: "get",
    silent: true,
    hideLoading: true,
  });
}

// 消息通知
export function getNotificationListApi(params) {
  return request({
    url: "/notification/list",
    method: "get",
    params,
  });
}

export function getNotificationUnreadCountApi() {
  return request({
    url: "/notification/unread-count",
    method: "get",
  });
}

export function getNotificationDetailApi(id) {
  return request({
    url: `/notification/detail/${id}`,
    method: "get",
  });
}

export function readAllNotificationsApi() {
  return request({
    url: "/notification/read-all",
    method: "post",
  });
}
